import React from "react";
import "./style.css";
import axios from 'axios';
import { CourseReview } from "../CourseReview/CourseReview";

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// import required modules
import { Pagination, Navigation } from 'swiper/modules';


export const HighlightedCourseReviews = ({
  id,
  selector,
  language
}) => {

  const translations = {
    "more": {
      "en": "View more reviews",
      "es": "Ver más valoraciones",
      "pt": "Ver mais opiniões",
      "fr": "Voir plus de notes"
    },
  };



  const [reviews, setReviews] = React.useState([]);

  const loadComments = () => {

    axios
      .get(`https://www.10masters.com/webapi/best_course_reviews/${id}/${language}/`) // TODO change to top reviews
      .then(res => {
        setReviews([...reviews, ...res.data]);
      })
      .catch(err => {
        console.log(err);
      });

  };

  const goToReviews = (e) => {

    selector("reviews");

  }

  React.useEffect(() => {

    loadComments();

  }, []);

  return (

    (document.body.clientWidth <= 576) ?

    <div className="course_highlighted_reviews_div">

      <Swiper
        centeredSlides={true}
        slidesPerView={'auto'}
        observer={false}
        observeParents={false}
        spaceBetween={'0'}
        rewind={false}
        navigation={false}
        pagination={{
          enabled: true,
          clickable: true
        }}
        modules={[Pagination, Navigation]}
      >

      {reviews.map((review, i) => (

      <SwiperSlide key={i}>
        <CourseReview
          key={review.id}
          name={review.name}
          instagram={review.instagram}
          avatar={review.avatar}
          points={review.score}
          text={review.body ? review.body : ''}
          highlighted={true}
          language={language}
        />
        </SwiperSlide>

      ))}

      </Swiper>

      <a className="show_more_reviews_link mb-5" href="#reviews" onClick={(event) => goToReviews(event)}>{translations["more"][language].toUpperCase()}
      <svg style={{marginLeft: '5px', marginTop: '-3.5px'}} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-right" viewBox="0 0 16 16">
        <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
        </svg>
      </a>

    </div>

    :

    <div className="course_highlighted_reviews_div">

      <div className="course_highlighted_reviews_list">

        {reviews.map((review, i) => (

          <CourseReview
            key={review.id}
            name={review.name}
            instagram={review.instagram}
            avatar={review.avatar}
            points={review.score}
            text={review.body ? review.body : ''}
            highlighted={true}
            language={language}
          />

        ))}

      </div>

      <a className="show_more_reviews_link mb-5" href="#reviews" onClick={(event) => goToReviews(event)}>{translations["more"][language].toUpperCase()}
      <svg style={{marginLeft: '5px', marginTop: '-3.5px'}} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-right" viewBox="0 0 16 16">
        <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
      </svg>
      </a>

    </div>


  );
};